import React from 'react';
import './DiceDisplay.css';
import { translations } from '../translations';

const DiceDisplay = ({ currentRoll, language }) => {
  const t = translations[language];
  
  return (
    <div className="dice-container">
      <div className="dice">
        <h3>{t.dice4Title}</h3>
        <div className="dice-face">
          {currentRoll.dice4 !== null ? currentRoll.dice4 : '-'}
        </div>
        <div className="dice-info">
          <p>{t.dice4Faces}</p>
        </div>
      </div>
      
      <div className="dice">
        <h3>{t.dice6Title}</h3>
        <div className="dice-face">
          {currentRoll.dice6 !== null ? currentRoll.dice6 : '-'}
        </div>
        <div className="dice-info">
          <p>{t.dice6Faces}</p>
        </div>
      </div>
      
      <div className="sum-display">
        <h3>{t.sum}</h3>
        <div className="sum">
          {currentRoll.sum !== null ? currentRoll.sum : '-'}
        </div>
      </div>
    </div>
  );
};

export default DiceDisplay; 